export enum CalendarViewType {
  MONTH,
  WEEK,
  DAY,
  LIST
}

export enum CalendarViewLabelType {
  MONTH = 'Month',
  WEEK = 'Week',
  DAY = 'Day',
  LIST = 'List'
}
